document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('newsroom-search');
    const sortSelect = document.getElementById('newsroom-sort');
    const categorySelect = document.getElementById('newsroom-category');
    const loadMoreButton = document.getElementById('load-more-button');
    const resetSearchButton = document.getElementById('reset-search');
    const postsContainer = document.getElementById('newsroom-posts-container');
    const resultsCount = document.getElementById('newsroom-results-count');
    
    const ajaxUrl = document.querySelector('#newsroom-data').getAttribute('data-ajax-url');
    const nonce = document.querySelector('#newsroom-data').getAttribute('data-nonce');
    
    let currentPage = 1;
    let isLoading = false;
    
    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
    
    function loadPosts(page = 1, append = false) {
        if (isLoading) return;
        isLoading = true;
        
        if (loadMoreButton) {
            loadMoreButton.disabled = true;
            loadMoreButton.innerHTML = '<span class="relative z-10">Loading...</span>';
        }
        
        const search = searchInput ? searchInput.value : '';
        const sort = sortSelect ? sortSelect.value : 'date-desc';
        const category = categorySelect ? categorySelect.value : '';
        
        const xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxUrl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        
        xhr.onload = function() {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                
                if (response.success) {
                    if (resultsCount) {
                        resultsCount.textContent = 'Showing ' + 
                            Math.min(response.data.showing, response.data.total) + 
                            ' of ' + response.data.total + ' articles';
                    }
                    
                    if (append) {
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = response.data.html;
                        const newPosts = tempDiv.querySelector('.space-y-8');
                        
                        if (newPosts) {
                            const existingPostsContainer = postsContainer.querySelector('.space-y-8');
                            existingPostsContainer.innerHTML += newPosts.innerHTML;
                        }
                    } else {
                        postsContainer.innerHTML = response.data.html;
                    }
                    
                    if (response.data.has_more) {
                        if (loadMoreButton) {
                            loadMoreButton.style.display = 'inline-flex';
                            loadMoreButton.disabled = false;
                            loadMoreButton.innerHTML = '<span class="relative z-10">Load More Articles</span>';
                            loadMoreButton.dataset.page = response.data.current_page;
                        }
                    } else if (loadMoreButton) {
                        const loadMoreContainer = document.getElementById('load-more-container');
                        if (loadMoreContainer) {
                            loadMoreContainer.style.display = 'none';
                        }
                    }
                    
                    if (!append) {
                        window.scrollTo({
                            top: postsContainer.offsetTop - 120,
                            behavior: 'smooth'
                        });
                    }
                }
            }
            
            isLoading = false;
        };
        
        const data = 'action=load_newsroom_posts&security=' + nonce + 
            '&search=' + encodeURIComponent(search) + 
            '&sort=' + encodeURIComponent(sort) + 
            '&category=' + encodeURIComponent(category) + 
            '&page=' + page;
        
        xhr.send(data);
    }
    
    if (searchInput) {
        searchInput.addEventListener('input', debounce(function() {
            currentPage = 1;
            loadPosts(currentPage, false);
        }, 500));
    }
    
    if (sortSelect) {
        sortSelect.addEventListener('change', function() {
            currentPage = 1;
            loadPosts(currentPage, false);
        });
    }
    
    if (categorySelect) {
        categorySelect.addEventListener('change', function() {
            currentPage = 1;
            loadPosts(currentPage, false);
        });
    }
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function() {
            currentPage = parseInt(this.dataset.page) + 1;
            loadPosts(currentPage, true);
        });
    }
    
    if (resetSearchButton) {
        resetSearchButton.addEventListener('click', function() {
            if (searchInput) searchInput.value = '';
            if (sortSelect) sortSelect.value = 'date-desc';
            if (categorySelect) categorySelect.value = '';
            currentPage = 1;
            loadPosts(currentPage, false);
        });
    }
});